import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from './styles.module.css';

@autobind
export default class Tabs extends Component {
    static propTypes = {
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
        size: PropTypes.oneOf(['medium', 'large']),
        selected: PropTypes.string.isRequired,
        stretch: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        theme: PropTypes.oneOf(['cultivio', 'latijereta', 'agroceres', 'expertobayer', 'agroeste', 'md', 'fieldview']),
    };

    static defaultProps = {
        size: 'medium',
    };

    handleChange(value) {
        return () => this.props.onChange(value);
    }

    render() {
        const className = classNames(styles.root, styles[this.props.size], { [styles.stretch]: this.props.stretch });

        return (
            <div className={className}>
                {this.props.tabs.map(({ value, label }) => (
                    <div
                        key={value}
                        className={classNames(styles[`theme-${this.props.theme}`], {
                            [styles.selected]: this.props.selected === value,
                        })}
                        onClick={this.handleChange(value)}
                    >
                        {label}
                    </div>
                ))}
            </div>
        );
    }
}
